import { Tooltip } from "antd";
import { FC, ReactNode } from "react";

const DBL_CLICK_DELAY = 400;

export const COLOR_SQUARE_WIDTH = 18;

interface LegendClickHolder {
  timeout: number;
  mouseDownTime: number;
  numClicks: number;
}

/** One for all squares: two quick clicks on different squares also count as a double click. */
const legendClickHolder: LegendClickHolder = { mouseDownTime: 0, numClicks: 0, timeout: 0 };

interface XmColorSquareProps {
  color: string;
  /** Dimmed when false */
  visible: boolean;
  tooltip: ReactNode;
  onClick: () => void;
  onDoubleClick: () => void;
}

/** Legend color square; a double click does not fire the single click. */
export const XmColorSquare: FC<XmColorSquareProps> = ({ color, visible, tooltip, onClick, onDoubleClick }) =>
  <Tooltip mouseLeaveDelay={0} mouseEnterDelay={0.2} title={tooltip}>
    <div onMouseDown={() => {
      const newMouseDownTime = Date.now();
      if (newMouseDownTime - legendClickHolder.mouseDownTime < DBL_CLICK_DELAY) {
        legendClickHolder.numClicks += 1;
      } else {
        legendClickHolder.numClicks = 1;
        legendClickHolder.mouseDownTime = newMouseDownTime;
      }
    }} onMouseUp={() => {
      if (Date.now() - legendClickHolder.mouseDownTime > DBL_CLICK_DELAY) {
        legendClickHolder.numClicks = Math.max(legendClickHolder.numClicks - 1, 1);
      }
      if (legendClickHolder.numClicks === 1) {
        window.clearTimeout(legendClickHolder.timeout);
        legendClickHolder.timeout = window.setTimeout(onClick, DBL_CLICK_DELAY);
      } else if (legendClickHolder.numClicks === 2) {
        window.clearTimeout(legendClickHolder.timeout);
        onDoubleClick();
      }
    }}
      onClick={event => event.stopPropagation()}
      style={{
        width: '9px', height: '9px', backgroundColor: color,
        border: '1px solid black',
        opacity: visible ? 1 : 0.4,
        cursor: 'pointer',
        margin: '0 auto'
      }}></div></Tooltip>;
